<template>
  <div>
    <div class="row">
      <div class="col-md">
        <label
          class="text-transform-none"
          style="color: #005d2c; font-size: 18px; max-width: 100%"
          >{{ dictionary.text_1 }} </label
        ><br /><br />
      </div>
    </div>
    <div class="row py-2">
      <div class="col-md" style="display: contents">
        <el-radio-group v-model="model.subscriptionType" class="ml-4">
          <el-radio
            :label="1"
            style="display: flex; align-items: center; padding-bottom: 15px"
            ><label style="color: #000; white-space: break-spaces"
              ><strong>{{ dictionary.label_1 }}</strong
              ><br />{{ dictionary.label_2 }}</label
            ></el-radio
          >
          <el-radio
            :label="2"
            style="display: flex; align-items: center; padding-bottom: 20px"
            ><label style="color: #000; white-space: break-spaces"
              ><strong>{{ dictionary.label_1 }}</strong
              ><br />{{ dictionary.label_2 }}</label
            ></el-radio
          >
        </el-radio-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <span style="color: #6ba652; font-size: 18px">{{
          dictionary.text_2
        }}</span>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <span style="font-size: 13px">{{ dictionary.text_3 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinTranslate from 'src/util/mixinTranslate';
import { RadioGroup, Radio, RadioButton } from 'element-ui';

export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
  },

  data() {
    return {
      model: {
        subscriptionType: 1,
      },
      dictionary: {
        text_1: null,
        text_2: null,
        text_3: null,
        label_1: null,
        label_2: null,
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinTranslate],

  methods: {
    En() {
      this.dictionary = this.translateEn()['threeStep'];
      this.globalDictionary = this.translateEn();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
    },
    Es() {
      this.dictionary = this.translateEs()['threeStep'];
      this.globalDictionary = this.translateEs();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
    },
    validated() {
      return this.$validator.validateAll().then((res) => {
        let band = true;
        if (band) {
          this.$emit('on-validated', res, this.model);
        }
        return band;
      });
    },
  },
  created() {
    if (sessionStorage.getItem('globalDictionary')) {
      this.dictionary = JSON.parse(
        sessionStorage.getItem('globalDictionary')
      ).threeStep;
    } else {
      this.Es();
    }
    this.showHideLoading();
  },
};
</script>
<style>
.el-radio__input.is-checked + .el-radio__label {
  color: #a4a69c;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #a4a69c;
  background: #a4a69c;
}
.el-radio__inner {
  border: 1px solid #a4a69c;
  border-radius: 100%;
  width: 18px;
  height: 18px;
}
.el-radio__inner:hover {
  border-color: #a4a69c;
}
</style>